import { createSelector } from 'reselect';
import type { StoreState } from '@common/types/store';
import type { IntegrationCommunitiesState } from '../reducers/integration-communities';

const getIntegrationCommunitiesState = (
  state: StoreState
): IntegrationCommunitiesState => state.admin.integrationCommunities || {
    loading: false,
    error: null,
    data: [],
  };

export const getIntegrationCommunities = createSelector(
  [getIntegrationCommunitiesState],
  (integrationCommunities) => integrationCommunities.data
);

export const getIntegrationCommunitiesLoading = createSelector(
  [getIntegrationCommunitiesState],
  (integrationCommunities) => integrationCommunities.loading
);

export const getIntegrationCommunitiesError = createSelector(
  [getIntegrationCommunitiesState],
  (integrationCommunities) => integrationCommunities.error
);

export const getAllNetworks = createSelector(
  [getIntegrationCommunities],
  (communityGroups) => {
    const allNetworks = new Map();

    communityGroups.forEach((group) => {
      group.linked_with.forEach((network) => {
        if (!allNetworks.has(network.id)) {
          allNetworks.set(network.id, {
            id: network.id,
            name: network.name,
          });
        }
      });
    });

    return Array.from(allNetworks.values());
  }
);

export const getUnlinkedCommunities = createSelector(
  [getIntegrationCommunities],
  (communityGroups) => {
    return communityGroups.filter(
      (group) => !group.linked_with || group.linked_with.length === 0
    );
  }
);
